import { NgModule } from 'ng-metadata/core';
import { VisaProcessingComponent } from './visa-processing.component';

@NgModule({
  declarations: [
    VisaProcessingComponent,
  ],
})
export class VisaProcessingModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/components/visa-processing/visa-processing.module.ts